import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale);

const Kpiresponsechart = forwardRef(({ chartData, option }, ref) => {
    const chartRef = useRef(null);

    useImperativeHandle(ref, () => ({
        chartInstance: chartRef.current?.chart, 
    }), []);
    
    
    return (
        <div style={{ width: '100%', height: '400px' }}>

        <Line
            data={chartData}
            option={option}
            ref={chartRef}
        />
        </div>
    );
});

export default Kpiresponsechart;